/* eslint-disable @next/next/no-img-element */
import React, { useEffect, useState } from 'react';
import DatePickerLib, { registerLocale, DatePickerProps } from 'react-datepicker';
import Styles from './DatePicker.css';
import ptbr from 'date-fns/locale/pt-BR';

/**
 *
 * @typedef {Object} CustomDatePickerProps
 * @property {DatePickerProps} datePickerProps
 * @property {string} error
 */

/**
 *
 * @param {CustomDatePickerProps} datePickerProps
 * @returns {React.JSX.Element}
 */

function DatePicker({
  placeholder,
  value,
  onChange,
  datePickerProps,
  error,
  completed,
  className,
}) {
  useEffect(() => {
    registerLocale('pt-BR', ptbr);
  }, []);

  return (
    <>
      <div className="sn-datepicker">
        <DatePickerLib
          {...datePickerProps}
          placeholderText={placeholder}
          selected={value}
          onChange={onChange}
          locale="pt-BR"
          dateFormat="dd/MM/yyyy"
          className={[
            !!error ? 'input-has-error' : '',
            completed ? 'input-completed' : '',
            className,
          ].join(' ')}
        />
        <span className="ic-container">
          <img src="assets/rastreadores/ic_calendar.svg" alt="" />
        </span>
      </div>

      {error && <p className="input-error-text">*{error}</p>}

      <style jsx>{Styles}</style>
    </>
  );
}

export default DatePicker;
